import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from '../models/types';

@Injectable()
export class ScannerQRService {
  url: any;
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
  }

  async callMomoAPI(qr: string, mach: string, amount: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/scannerQR`, {
      QR_ID: qr,
      maCH: mach,
      amount: amount,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else
        {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

  async callQueryMomoAPI(mach: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/QueryMomo`, {
      maCH: mach,
      maHTTT: maHTTT, maQuay: maQuay,
      MaNV: MaNV, STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result);
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/ScannerQR.service.ts